import { vBTooltip } from 'bootstrap-vue-next'

export default {
  install(app) {
    app.directive('b-tooltip', vBTooltip)
  },
}
